// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  enabled:
    process.env.APP_ENV === 'production' ||
    process.env.APP_ENV === 'staging' ||
    process.env.APP_ENV === 'experimental',
  environment: process.env.APP_ENV || 'development',
  normalizeDepth: 5,
  integrations: [
    Sentry.captureConsoleIntegration({
      levels: ['warn', 'error', 'debug', 'assert'],
    }),
    Sentry.browserTracingIntegration({}),
  ],
  ignoreErrors: ['ResizeObserver loop limit exceeded'],
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
